/* eslint-disable class-methods-use-this */
import { NotificationProgrammatic as Notification } from 'buefy';
// import getEnv from '@/utils/env';

import store from '../store';
import router from '../router';
import CmsUtils from '.';

class CmsConsts {
  // Create `axios` instance with pre-configured `axios-cache-adapter` attached to it
  constructor() {
    this.list_html_tags_for_sections_and_slots = [
      'article',
      'aside',
      'details',
      'div',
      'figure',
      'footer',
      'header',
      'hgroup',
      'nav',
      'section',
      'span',
      'summary',
      'ul',
    ];
  }

  getListHtmlTagForSectionsAndSlots() {
    return this.list_html_tags_for_sections_and_slots;
  }

  // getHomePageLink() {
  //   return this.homePageLink;
  // }

  async getUrlByPageId(languageCode, pageId) {
    try {
      if (!pageId || pageId === '') {
        return `/${languageCode}`;
      }
      const res = await new CmsUtils().getPageRouteByPageId(pageId);
      if (res.page_route_content && res.page_route_content.routes) {
        const routes = res.page_route_content.routes.filter(
          (i) => i['language-code'] === languageCode
        );
        let route = res.page_route_content.routes.find(
          (i) => i.default === true
        );
        if (!route) {
          [route] = routes;
        }
        return `/${route['language-code']}${route.route}`;
      }
      return `/${languageCode}`;
    } catch (e) {
      return '';
    }
  }

  async getUrlsByPageId(languageCode, pageId) {
    try {
      if (!pageId || pageId === '') {
        return `/${languageCode}`;
      }
      const res = await new CmsUtils().getPageRouteByPageId(pageId);
      if (res.page_route_content && res.page_route_content.routes) {
        const routes = res.page_route_content.routes.filter(
          (i) => i['language-code'] === languageCode
        );
        return routes.map(
          (route) => `/${route['language-code']}${route.route}`
        );
      }
      return `/${languageCode}`;
    } catch (e) {
      return '';
    }
  }

  getUrlByPageRoute(languageCode, pageRoute) {
    try {
      if (!pageRoute || pageRoute === '') {
        return `/${languageCode}`;
      }
      if (pageRoute.page_route_content && pageRoute.page_route_content.routes) {
        const routes = pageRoute.page_route_content.routes.filter(
          (i) => i['language-code'] === languageCode
        );
        let route = pageRoute.page_route_content.routes.find(
          (i) => i.default === true
        );
        if (!route) {
          [route] = routes;
        }
        return `/${route['language-code']}${route.route}`;
      }
      return `/${languageCode}`;
    } catch (e) {
      return '';
    }
  }

  getParent(component, name) {
    let p = component.$parent;
    let res = false;
    while (typeof p !== 'undefined') {
      if (p.$options.name === name) {
        res = p;
        break;
      }
      p = p.$parent;
    }
    return res;
  }

  getValueFromParent(component, valueName, parentName) {
    const parent = this.getParent(component, parentName);
    if (parent && parent.data) {
      if (parent.data[valueName] !== undefined) {
        return parent.data[valueName];
      }
    }
    return false;
  }

  getValueFromPageLoaderVariables(component, valueName) {
    const res = this.getValueFromParent(component, 'variables', 'PageLoader');
    if (res && res[valueName]) {
      return res[valueName];
    }
    return false;
  }

  setDynamicParametersForPageLoaderVariables(component, dynamicParameters) {
    const parent = this.getParent(component, 'PageLoader');
    if (parent && parent.data && parent.data.variables) {
      dynamicParameters.forEach((parameter) => {
        if (
          parameter.sections &&
          parameter.sections.map((i) => i['section-id']) &&
          parameter['data-series'] &&
          parameter['data-series'].map((i) => i['section-id'])
        ) {
          parameter.sections
            .map((i) => i['section-id'])
            .forEach((sectionId) => {
              parameter['data-series']
                .map((i) => i['data-series-id'])
                .forEach((dataSeriesId) => {
                  if (parent.data.variables[sectionId] === undefined) {
                    parent.data.variables[sectionId] = {};
                  }
                  if (
                    parent.data.variables[sectionId][dataSeriesId] === undefined
                  ) {
                    parent.data.variables[sectionId][dataSeriesId] = {};
                  }
                  if (
                    parent.data.variables[sectionId][dataSeriesId][
                      parameter['data-series-variable-name']
                    ] === undefined
                  ) {
                    parent.data.variables[sectionId][dataSeriesId][
                      parameter['data-series-variable-name']
                    ] = parameter.value;
                  }
                });
            });
        }
      });
    }
  }

  notificationSuccess(textMessage) {
    Notification.open({
      duration: 4000,
      message: textMessage,
      type: 'is-success',
      hasIcon: true,
      queue: false,
    });
  }

  notificationError(textMessage) {
    Notification.open({
      duration: 4000,
      message: textMessage,
      type: 'is-danger',
      hasIcon: true,
      queue: false,
    });
  }

  notificationWarning(textMessage) {
    Notification.open({
      duration: 4000,
      message: textMessage,
      type: 'is-warning',
      hasIcon: true,
      queue: false,
    });
  }

  logout(route = null) {
    store.dispatch('signOut').then(() => {
      if (route !== null) {
        router.push(route);
      }
    });
  }
}

export default CmsConsts;
